// extracted by mini-css-extract-plugin
module.exports = {"scale":"ColorScale_scale__1MTYj","color":"ColorScale_color__2EO7I"};